import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ApOptionSelectedValidator {
    /**
     * Validate if value in control is in list of options
     */
    public static validate(options: string[] | Record<string, any>): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const selection: string = control.value;

            //Validation of objects is skipped.
            //It is only possible to select a value as object when
            //selection in done through the component itself.
            //The validator needs optionKey to be validated which it now has not.
            if (selection && typeof selection === 'object') {
                return null;
            }

            if (options.indexOf(selection) === -1) {
                return { incorrect: true };
            }
            return null;
        };
    }
}
